import { useEffect, useState } from 'react';
import { fetchMonthlyWarriorCount } from '@/lib/impact-counters';

interface UseMonthlyWarriorCountResult {
  count: number;
  loading: boolean;
}

export function useMonthlyWarriorCount(): UseMonthlyWarriorCountResult {
  const [count, setCount] = useState(847);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const load = async (): Promise<void> => {
      const next = await fetchMonthlyWarriorCount();
      if (!cancelled) {
        setCount(next);
        setLoading(false);
      }
    };

    void load();
    return () => {
      cancelled = true;
    };
  }, []);

  return { count, loading };
}
